export const UPDATE_PAGE_SIZE_VALUE = 'UPDATE_PAGE_SIZE_VALUE';

export const updatePageSizeValue = value => ({
  type: UPDATE_PAGE_SIZE_VALUE,
  value,
});
